module.exports = __webpack_public_path__ + "dimer/static/img/project3.c1f879e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project3.jpg
// module id = wbQq
// module chunks = 0